import { Flex, Text } from '@chakra-ui/react';
import { OutlineCard } from '@morressier/alembic';
import { ISubmissionContext } from '@publishing-engine/domain/models';
import { useEffect, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import SubmissionStepContentSection from './SubmissionStepContentSection';
import {
  ISubmissionStepContentForm,
  SUBMISSION_STEP_CONFIGS,
  buildSubmissionStepDefaultValues
} from './stepConfig';

const SubmissionStepsContentConfig = ({
  journal
}: {
  journal: ISubmissionContext;
}) => {
  const methods = useForm<ISubmissionStepContentForm>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: buildSubmissionStepDefaultValues(
      journal?.config?.cms?.authorSubmissionForm
    )
  });
  const { reset } = methods;

  const authorSubmissionForm = journal?.config?.cms?.authorSubmissionForm;
  const stepContentDefaults = useMemo(
    () => buildSubmissionStepDefaultValues(authorSubmissionForm),
    [authorSubmissionForm]
  );

  useEffect(() => {
    if (journal?.config?.cms) {
      reset(stepContentDefaults);
    }
  }, [journal, reset, stepContentDefaults]);

  return (
    <>
      <FormProvider {...methods}>
        <Flex flexDirection={'column'} gap={6}>
          <Text textStyle={'headingSection'}>Author Submission Steps Header Content</Text>
          <OutlineCard borderless paddingX={4} paddingY={6}>
            <Flex flexDirection="column" flex="1" gap={6}>
              {SUBMISSION_STEP_CONFIGS.map(step => (
                <SubmissionStepContentSection
                  key={step.key}
                  title={step.title}
                  stepKey={step.key}
                  stepContent={
                    stepContentDefaults.config.cms.authorSubmissionForm[step.key]
                  }
                  journalId={journal.id}
                />
              ))}
            </Flex>
          </OutlineCard>
        </Flex>
      </FormProvider>
    </>
  );
};

export default SubmissionStepsContentConfig;
